<template>
    <div class="widget" v-bind:class="[{'loaded':loaded},className]">

        <header class="widget-header">
            <h2 class="widget-title">{{ title }}</h2>
            <h3 class="widget-title-period">
                <span v-for="item in periods" v-if="item.id == period">{{ item.label }}</span>
            </h3>

            <div class="widget-actions-container">
            <widget-dropdown v-model="period" :options="periods" :callback="filterByPeriod"></widget-dropdown>
            </div>

            <div class="form-advanced-filter" v-if="showAdvancedFilterVue">
                <span>Filtrer par date</span>
                <div class="date-filters">
                    <form-datex label="du" v-model="dateFilter.start_at" :hide-time="false" time="00:00:00"></form-datex>
                    <form-datex label="au" v-model="dateFilter.end_at" :hide-time="false" time="23:59:59"></form-datex>
                </div>
            </div>

        </header>

        <div class="widget-preloader">
            <div class="pre-loader">
                <div class="box1"></div>
                <div class="box2"></div>
                <div class="box3"></div>
                <div class="box4"></div>
                <div class="box5"></div>
            </div>
        </div>

        <div class="widget-content" v-if="stats.dataset">
            <div class="widget-content-datas">
                <div v-for="item, key in allDatasets">
                    <div class="data-label tab" @click="selectData(key)" v-bind:class="{active: selected == key}">
                        <strong>{{ stats.total[key].value }}</strong>
                        <span class="compare increase" v-if="stats.total[key].last < stats.total[key].value">+ {{ (stats.total[key].value - stats.total[key].last) }}</span>
                        <span class="compare decrease" v-if="stats.total[key].last > stats.total[key].value">- {{ (stats.total[key].last - stats.total[key].value) }}</span>
                        <img :src="'/src/assets/flags/'+key.toLowerCase()+'.svg'"/>
                    </div>
                </div>
            </div>

            <div class="widget-chart" v-bind:class="{'active':stats.labels.length}">
                <chart :dataset="stats.dataset" :labels="stats.labels" :options="options" v-if="stats"></chart>
            </div>
            <!--
            <div v-for="item in stats.dataset">
                {{ item.name }} {{ item.value }}
            </div>
            -->
        </div>
    </div>
</template>
<script>

    import OrderService from './OrderService.js';
    import Pie from '../../../components/chart/Pie.vue'

    export default {
        name: 'Widget',
        components: {
            'chart' : Pie
        },
        props: ['title','period','className'],
        data () {
            return {
                periods: [
                    {id: 'last_7days', label: '7 derniers jours'},
                    {id: 'current_month', label: 'Ce mois'},
                    {id: 'last_month', label: 'Le mois dernier'},
                    {id: 'since_1_month', label: '30 derniers jours'},
                    {id: 'since_3_months', label: '90 derniers jours'},
                    {id: 'current_year', label: 'Cette année'},
                    {id: 'last_year', label: 'Depuis 12 mois'},
                    {id: 'all', label: 'Tout'},
                    {id: 'custom', label: 'Personnalisé'},
                ],
                loaded: false,
                selected: null,
                allDatasets: null,
                stats: {
                    dataset: null,
                    labels: null
                },
                dateFilter: {
                    start_at: '',
                    end_at: '',
                },
                showAdvancedFilterVue: false,
                count: null,
                total: null,
                options: {
                    layout: {
                        padding: {
                            left: 0,
                            right: 10,
                            top: 0,
                            bottom: 0
                        }
                    },
                    legend: {
                        reverse: true
                    },
                    plugins: {
                        labels: [
                            {
                                //render: 'value', // percentage
                                fontSize: 13,
                                fontColor: '#333',
                                fontStyle: 'bold',
                                precision: 0,
                                //position: 'outside'
                                render: function (args) {
                                    // args will be something like:
                                    // { label: 'Label', value: 123, percentage: 50, index: 0, dataset: {...} }
                                    return args.value + " (" + args.percentage + "%)";
                                }
                            }
                        ],
                    },
                    tooltips: {
                        callbacks: {
                            label: function(tooltipItems, data) {
                                return data.labels[tooltipItems.index] + ' (' + data.datasets[tooltipItems.datasetIndex].label + ') : ' + data.datasets[tooltipItems.datasetIndex].data[tooltipItems.index];
                            }
                        }
                    }
                }
            }
        },
        mounted: function(){

            this.period = this.period ? this.period : this.periods[0].id

            if(this.period == 'custom') {
                this.showAdvancedFilterVue = true
            }else{
                this.showAdvancedFilterVue = false;
            }

            this.filterByPeriod(this.period);

        },
        watch: {
            'dateFilter.start_at'(newVal, oldVal) {
                if(newVal != '' && this.dateFilter.end_at != ''){
                    this.filterByPeriodAndByDate(this.period, this.dateFilter);
                }
            },
            'dateFilter.end_at'(newVal, oldVal) {
                if(newVal != '' && this.dateFilter.start_at != ''){
                    this.filterByPeriodAndByDate(this.period, this.dateFilter);
                }
            }
        },
        methods: {
            selectData: function(lang)
            {
                this.stats.dataset = this.allDatasets[lang]
                this.selected = lang
            },
            filterByPeriod: function(period)
            {

                if(period == 'custom') {
                    this.showAdvancedFilterVue = true
                }else{
                    this.showAdvancedFilterVue = false;
                }

                if(period != 'custom') {

                    this.loaded = false;
                    this.period = period

                    OrderService.getCustomersByLanguage( this.period ).then((response) => {

                        this.allDatasets = response.data.result.stats.dataset
                        this.selected = 'FR'

                        this.stats.dataset = this.allDatasets.FR
                        this.stats.labels = response.data.result.stats.labels
                        this.stats.total = response.data.result.stats.total


                        this.loaded = true;
                    }).catch((response) => {
                        console.log("error", response);
                        this.loaded = true;
                    })

                }
            },
            filterByPeriodAndByDate: function(period, dateFilter)
            {
                this.loaded = false;

                this.period = period
                this.date = JSON.stringify(dateFilter);

                OrderService.getCustomersByLanguage( this.period, this.date ).then((response) => {

                    this.allDatasets = response.data.result.stats.dataset
                    this.selected = 'FR'

                    this.stats.dataset = this.allDatasets.FR
                    this.stats.labels = response.data.result.stats.labels
                    this.stats.total = response.data.result.stats.total

                    this.loaded = true;
                }).catch((response) => {
                    console.log("error", response);
                    this.loaded = true;
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/shop/order/OrderCustomerWidget.vue